import * as Yup from "yup";

export const commentSchema = Yup.object().shape({
  name: Yup.string().required("O nome é obrigatório"),
  text: Yup.string().required("O texto é obrigatório"),
  starts: Yup.number().required("Informe sua nota"),
  description: Yup.string().required("A descrição é obrigatória"),
});
